<div class="container-fluid">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a>Field Visit</a></li>
            <li class="breadcrumb-item active" aria-current="page">Approval Request</li>
        </ol>
    </nav>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <form [formGroup]="approvalRequestForm" style="margin: 20px;">
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="">Field Visit ID</label>
                            <input type="text" placeholder="Auto generated ID" class="form-control"
                                formControlName="_id" disabled>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="">Account ID</label>
                            <input disabled type="text" placeholder="Account ID" class="form-control"
                                formControlName="account_id" disabled>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="">Field Visit Territory</label>
                            <select class="form-control" formControlName="fieldvisitterritory" disabled>
                                <option value="">Choose</option>
                                <option *ngFor="let item of areaCodeList" [value]="item.areacode">{{item.areacode}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="">Field Visit Area</label>
                            <select class="form-control" formControlName="fieldvisitarea" disabled>
                                <option value="">Choose</option>
                                <option *ngFor="let item of fieldvisitCodeList" [value]="item.fvcode">{{item.fvcode}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="">First Address</label>
                            <input type="text" placeholder="First address" class="form-control"
                                formControlName="firstaddress" disabled>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="">Second Address</label>
                            <input type="text" placeholder="Second address" class="form-control"
                                formControlName="secondaddress" disabled>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="">Field Visit Request Date</label>
                            <input type="date" placeholder="Auto generated ID" class="form-control"
                                formControlName="fvrqdate">
                        </div>

                        <div class="form-group col-md-12">
                            <label for="">Agent Remarks</label>
                            <textarea name="" id="" cols="30" rows="5" placeholder="Remarks" class="form-control"
                                formControlName="remarks"></textarea>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="">FV done date</label>
                            <input type="date" placeholder="Auto generated ID" class="form-control"
                                formControlName="FV_Done_Date">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="">Phone Numbers Obtained</label>
                            <input type="text" placeholder="Numbers_Obtained" class="form-control"
                                formControlName="Numbers_Obtained">
                            <!-- <select class="form-control" formControlName="Numbers_Obtained">
                                <option value="">Choose</option>
                                <option *ngFor="let item of agentList" [value]="item._id">{{item.name}}</option>
                            </select> -->
                        </div>
                        <div class="form-group col-md-12">
                            <label for="">FV Coordinater Feedback</label>
                            <textarea name="" id="" cols="30" rows="5" placeholder="FV_Coordinater_Feedback"
                                class="form-control" formControlName="FV_Feedback"></textarea>
                        </div>
                        <div class="form-group col-md-12">
                            <input type="file" class="custom-file-input" id="customFile" (change)="getFile($event)"
                                disabled>
                            <label class="custom-file-label" for="customFile">Choose file</label>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="">Status</label>
                            <select formControlName="approval_status" class="form-control">
                                <option value="">Choose</option>
                                <option value="requested">Requested</option>
                                <option value="approved">Approved</option>
                                <option value="done">Done</option>
                                <option value="not done">Not Done</option>
                                <option value="pending">Pending</option>
                                <option value="revisit">Revisit</option>
                            </select>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-sm btn-success" (click)="editapprovalRequest()"
                            *ngIf="addmode">Edit</button>
                        <button class="btn btn-sm btn-success" (click)="updateapprovalRequest()"
                            *ngIf="editmode">Approve</button>
                        <button class="btn btn-sm btn-success" (click)="cancel()" *ngIf="editmode">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <ag-grid-angular #agGrid 
                style="width: auto; height: 500px;" 
                class="ag-theme-alpine"
                [rowData]="approvalRequestList" 
                [rowSelection]="'multiple'" 
                [columnDefs]="approvalRequestcolumnDefs"
                [pagination]="true" 
                (gridReady)="onGridReady($event)" 
                (click)="onGetSelectedRowId()" >

            </ag-grid-angular>

           
        </div>
    </div>

</div>